import { makeStyles } from 'tss-react/mui';

const name = 'ChainMenu';

export const useChainMenuStyles = makeStyles({ name })(theme => ({
  root: {
    overflow: 'visible',

    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),

    paddingRight: theme.spacing(0.5),
  },
}));
